// ============================================================
// project.js
// ------------------------------------------------------------
// จัดการ "โครงการที่กำลังใช้งานอยู่"
// ทุกหน้าจอหลังจากนี้อ่านค่าโครงการจาก localStorage ที่ตั้งไว้ตรงนี้
// ============================================================

import { setStorageAll } from "../core/storage.js";

// ประกอบที่อยู่เต็มของโครงการจากข้อมูลตำบล/อำเภอ/จังหวัด
// เผื่อกรณี address_obj ไม่มา (ข้อมูลเก่า) จะได้ไม่ทำให้หน้าจอค้าง
const buildAddress = (item) => {
  const addr = item.address_obj;
  if (!addr) return item.address_detail || "-";
  return `${item.address_detail} ต.${addr.SUB_DISTRICT} อ.${addr.DISTRICT} จ.${addr.PROVINCE} ${addr.ZIPCODE}`;
};

// เลือกโครงการ — เก็บข้อมูลโครงการทั้งชุดลง localStorage
// รวมถึง id ของเอกสารต่าง ๆ ที่หน้าพิมพ์เอกสารต้องใช้ (ใบเสร็จ / ใบแจ้งหนี้ / หนังสือแจ้ง)
export const selectProject = (item) => {
  // NOTE ของที่ผูกกับ "โครงการเดิม" ต้องล้างทุกครั้งที่สลับโครงการ ไม่งั้นข้อมูลข้ามโครงการ
  //   replace_text = ชื่อค่าใช้จ่ายที่โครงการตั้งเอง cache ไว้ 30 นาที
  //                  เดิมล้างเฉพาะตอนกดชื่อโครงการบน Navbar เท่านั้น
  //                  ถ้าเข้ามาทางล็อกอินใหม่แล้วเลือกอีกโครงการ จะได้ชื่อค่าใช้จ่ายของโครงการเดิมไป 30 นาที
  //   sync_date    = วันที่คำนวณยอดค้างรอบล่าสุด เดิมเก็บเป็นค่าเดียวไม่แยกโครงการ
  //                  สลับโครงการวันเดียวกันแล้วระบบข้ามการคำนวณ ทำให้ยอดค้าง/เบี้ยปรับของโครงการใหม่ไม่อัปเดต
  localStorage.removeItem("replace_text");
  localStorage.removeItem("sync_date");

  setStorageAll({
    project_id: item.project_id,
    project_number: item.project_number,
    project_name: item.project_name,
    project_address: buildAddress(item),
    phone_number: item.phone_number || "-",
    tax_number: item.tax_number || "-",
    water_id: item.setting_water_id, // ชุดตั้งค่าอัตราค่าน้ำของโครงการ
    receipt_id: item.receipt_id, // แม่แบบใบเสร็จ
    room_id: item.invoice_room_id, // แม่แบบใบแจ้งหนี้รายห้อง
    letter_id: item.warning_letter_id, // แม่แบบหนังสือแจ้งเตือน
    picture_paper: item.picture_paper, // รูปหัวกระดาษเอกสาร
  });
};
